import * as React from 'react';
import antd from 'antd';
import { ArrivalScheduleHandler } from '../ArrivalScheduleHandler';
import moment from 'moment';
import { ArrivalScheduleModel } from '../Models/ArrivalScheduleModel';
import { NavLink } from 'react-router-dom';
import Utility from 'Core/Utility';
export interface Props {
  children?: React.ReactNode;
  listItems?: any;
  dateSearched?: any;
  isHomeMode?: boolean;
  shipName?: string;
}

export interface State { }

const { Table } = antd;
export default class ArrivalScheduleDataTable extends React.Component<Props, State> {
  private columns = [
    {
      title: 'ETA',
      dataIndex: 'expectedArrivalDateTime',
      key: 'expectedArrivalDateTime',
    },
    {
      title: 'VESSEL',
      dataIndex: 'shipName',
      key: 'shipName',
    },
  ];

  constructor(props: Props) {
    super(props);
  }

  render() {
    const pageSize = this.props.isHomeMode ? 3 : 10;
    const searchDate = this.props.dateSearched;
    return (
      <div style={{ textAlign: 'center' }}>
        <p style={{ float: 'left' }}>Showing results for: &nbsp;</p>
        <p style={{ float: 'left', display: 'inline-block' }}> {searchDate || 'All Dates'}</p>
        {this.props.isHomeMode === true ? (
          <NavLink to="/vessel-schedule">More Details</NavLink>
        ) : (
            <p style={{ textAlign: 'right' }}>{this.props.shipName || 'All Vessels'}</p>
          )}
        <Table
          columns={this.columns}
          dataSource={this.props.listItems}
          pagination={this.props.listItems.length > pageSize ? { pageSize: pageSize } : false}
        />
      </div>
    );
  }
}
